// apps/web/src/lib/epk-draft-types.ts

export type EpkVariant =
  | 'concert'
  | 'festival'
  | 'corporate'
  | 'private_party'
  | 'charity_gala'
  | 'commercial_tv_film'
  | 'casino'
  | 'general'

export type DraftStatus = 'draft' | 'in_review' | 'authorised' | 'archived'

export interface DraftRecord {
  id: string
  artistId: string
  variant: EpkVariant
  htmlBody: string
  cssBody: string
  version: number
  status: DraftStatus
  label: string | null
  pdfS3Key: string | null
  pdfFilename: string | null
  pdfUploadedAt: string | null
  authorisedAt: string | null
  authorisedBy: string | null
  archivedAt: string | null
  createdAt: string
  updatedAt: string
}

export const EPK_VARIANT_LABELS: Record<EpkVariant, string> = {
  concert: 'Concert',
  festival: 'Festival',
  corporate: 'Corporate',
  private_party: 'Private party',
  charity_gala: 'Charity gala',
  commercial_tv_film: 'Commercial / TV / Film',
  casino: 'Casino',
  general: 'General',
}

export const VARIANT_FROM_EVENT_TYPE: Record<string, EpkVariant> = {
  concert: 'concert',
  festival: 'festival',
  corporate: 'corporate',
  private_party: 'private_party',
  charity_gala: 'charity_gala',
  commercial_tv_film: 'commercial_tv_film',
  casino: 'casino',
  residency: 'casino',
  special_request: 'general',
  other: 'general',
}
